import React from "react"
import { Modal, Form, Input, InputNumber, Select, Button, Spin } from "antd"

import { LoadingOutlined } from "@ant-design/icons"

import PropTypes from 'prop-types'

import { AdminService } from "@/services"

import { FileUploader } from "@/utils"

const { Option } = Select

class SellingSiteEditModal extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            ready: false,
            allTags: [],
            allDevices: [],
            formData: props.formData,
            previewCoverImage: props.previewCoverImage
        }
    }

    componentDidMount() {
        const params = {}
        AdminService.get_selling_site_filters(params).then((response) => {
            const { status, body } = response.data
            if (status <= 0) {
                console.error("get_selling_site_filters api return status", status)

                this.setState({ ready: true })

                return
            }

            this.setState({
                allTags: body.tags,
                allDevices: body.devices,
                ready: true
            })
        })
    }

    updateFormData(mergeData) {

        const { formData } = this.state

        const newFormData = {
            ...formData,
            ...mergeData
        }

        this.setState({ formData: newFormData })
    }

    onCancel() {
        this.props.onCancel()
    }

    onSubmit() {
        const { formData } = this.state
        this.props.onSubmit(formData)
    }

    onClickUploadCoverImage() {
        const uploader = new FileUploader()
        uploader.chooseFile({
            onSelect: (newFile) => {
                this.updateFormData({ coverImage: newFile })

                const fr = new FileReader()
                fr.onload = () => {
                    this.setState({ previewCoverImage: fr.result })
                }

                fr.readAsDataURL(newFile)
            }
        })
    }

    renderPreviewCoverImage() {

        const { previewCoverImage } = this.state

        const wrapStyle = {
            width: 160,
            height: 90,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #222",
            background: "#666",
            borderRadius: 3,
            overflow: "hidden"
        }

        return (
            <div style={wrapStyle}>
                <img
                    src={previewCoverImage}
                    style={{ maxWidth: "100%", maxHeight: "100%", verticalAlign: "middle" }}
                    alt=""
                />
            </div>
        )
    }

    renderLoading() {

        const loadingIcon = <LoadingOutlined type="loading" style={{ fontSize: 40, marginBottom: 10 }} spin />

        const style = {
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center"
        }

        return (
            <div style={style}>
                <Spin tip="正在加载中，请稍候..." indicator={loadingIcon}></Spin>
            </div>
        )
    }

    renderModalContent() {
        const { ready, formData, allDevices, allTags } = this.state

        if (!ready) return this.renderLoading()

        return (
            <div style={{ width: "100%", height: "100%", overflow: "hidden", position: "relative" }}>
                <Form layout="vertical">
                    <Form.Item label="模板ID">
                        <InputNumber
                            size="small"
                            value={formData.collectionSiteId}
                            placeholder="请输入模板ID"
                            style={{ width: "100%" }}
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(value) => this.updateFormData({ collectionSiteId: value })}
                        />
                    </Form.Item>
                    <Form.Item label="标题">
                        <Input
                            size="small"
                            value={formData.name}
                            placeholder="请输入精选模板标题"
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(e) => this.updateFormData({ name: e.target.value })}
                        />
                    </Form.Item>
                    <Form.Item label="描述">
                        <Input
                            size="small"
                            value={formData.description}
                            placeholder="请输入精选模板描述"
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(e) => this.updateFormData({ description: e.target.value })}
                        />
                    </Form.Item>
                    <Form.Item label="封面图">
                        <div style={{ display: "flex", alignItems: "flex-end", overflow: "hidden" }}>
                            {this.renderPreviewCoverImage()}
                            <div style={{ marginLeft: 8, position: "relative" }}>
                                <Button
                                    onClick={() => this.onClickUploadCoverImage()}
                                    style={{ display: "block", marginTop: 8, marginLeft: 13, textAlign: "center" }}
                                >上传背景图</Button>
                            </div>
                        </div>
                    </Form.Item>

                    <Form.Item label="关联设备">
                        <Select
                            mode="multiple"
                            size="small"
                            value={formData.devices}
                            placeholder="请选择关联设备"
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(devices) => this.updateFormData({ devices: devices })}
                        >
                            {allDevices.map((device) => (<Option value={device.id} key={device.id}>{device.name}</Option>))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="关联场景">
                        <Select
                            mode="multiple"
                            size="small"
                            value={formData.tags}
                            placeholder="请选择关联场景"
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(tags) => this.updateFormData({ tags: tags })}
                        >
                            {allTags.map((tag) => (<Option value={tag.id} key={tag.id}>{tag.name}</Option>))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="适用平台">
                        <Select
                            size="small"
                            value={formData.platform}
                            placeholder="请选择使用平台"
                            onKeyDown={(e) => e.stopPropagation()}
                            onChange={(value) => this.updateFormData({ platform: value })}
                        >
                            <Option value={"common"}>通用</Option>
                            <Option value={"jowoiot"}>九物云</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="是否公开">
                        <Select
                            style={{ width: "100%" }}
                            value={formData.isPublic}
                            onChange={(value) => this.updateFormData({ isPublic: value })}
                            size="small"
                            dropdownClassName="ant-jowo-overrides"
                        >
                            <Option value={true}>公开</Option>
                            <Option value={false}>不公开</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </div>
        )
    }

    render() {

        return (
            <Modal
                title="添加精选模板"
                visible={true}
                maskClosable={false}
                keyboard={false}
                onCancel={() => this.onCancel()}
                width={500}
                okText='保存'
                cancelText='取消'
                onOk={() => this.onSubmit()}
            >
                {this.renderModalContent()}
            </Modal>
        )
    }
}

SellingSiteEditModal.propTypes = {
    formData: PropTypes.object.isRequired,
    previewCoverImage: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

const defaultFormData = {
    id: "",
    collectionSiteId: "",
    name: "",
    description: "",
    coverImage: null,
    devices: [],
    tags: [],
    platform: "common",
    isPublic: true
}

SellingSiteEditModal.defaultProps = {
    formData: defaultFormData,
    previewCoverImage: ""
}

export default SellingSiteEditModal